<template>
    <div class="user_order" v-loading="loading">
        <div class="order_titles">我的委托</div>
        <div class="user_order_box">
            <div class="order_types">
                <div class="lefts">
                    <div class="types" :class="{types_ac:types_ac==item.state}" v-for="(item,index) in type_list" :key="index" @click="handle_type(item)">
                        {{ item.title }}
                    </div>
                </div>
                <div class="rights">
                    <el-input
                        placeholder="输入商品名称、订单号"
                        v-model="keyword">
                        <div slot="suffix" class="" @click="handle_seach">
                            <img src="../../../../assets/img/user_info/user_order/seach.png" alt="">
                        </div>
                    </el-input>
                </div>
            </div>
            <div class="order_0" v-if="order_list.length==0">
                <img src="@/assets/img/user_info/user_grzx/order_0.png" alt="">
                <div class="texts">暂无待处理订单 </div>
            </div>
            <div class="order_list" v-if="order_list.length>0">
                <div class="order_tabs">
                    <div class="tables tab1">服务</div>
                    <div class="tables tab2">创建时间</div>
                    <!-- <div class="tables tab3">金额</div> -->
                    <div class="tables tab4">状态</div>
                    <div class="tables tab5">操作</div>
                </div>
                <div class="order_items">
                    <div class="items" v-for="(item,index) in order_list" :key="index">
                        <div class="item1">
                            {{( item.pro||{}).title }}
                        </div>
                        <div class="item2">{{ item.created_at}}</div>
                        <!-- <div class="item3">2022-10-21 12:24:30</div> -->
                        <div class="item4">
                            <div class="tages tages5" v-if="item.status==20">待服务</div>
                            <div class="tages tages3" v-if="item.status==30">服务中</div>
                            <div class="tages tages4" v-if="item.status==40">已完成</div>
                            <div class="tages tages4" v-if="item.status==50">已完成</div>
                        </div>
                        <div class="item5">
                            <div class="btns" @click="handle_deitial(item)">查看详情</div>
                            <div class="borders"  v-if="item.status==30||item.status==20">丨</div>
                            <div class="btns"  v-if="item.status==30||item.status==20" @click="handle_deitial(item)">补充资料</div>



                        </div>
                    </div>
                </div>
            </div>
            <div class="pages_box">
                <div class="btns" @click="handle_pages(1)">首页</div>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pages.page"
                    background
                    :page-size="pages.limit"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
                <div class="btns"  @click="handle_pages(last_page)">尾页</div>
            </div>
        </div>
        
    </div>
</template>
<script>
import { mapState} from 'vuex'
 
 

export default {
    components: {
       
    },
    name: "homes",
    data() {
        return {
            loading: false,
            keyword:'',//
            types_ac:0,
            type_list:[
                {
                    title:'全部委托',
                    state:0,
                },
                {
                    title:'待服务',
                    state:20,
                },
                {
                    title:'服务中',
                    state:30,
                },
                {
                    title:'已完成',
                    state:40,
                }
                
            ],
            order_list:[],

            total:100,
            pages:{
                page:1,
                limit:10,
            },
            last_page:1,
           
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_list()
    },
    methods: {
        handle_type(item){
            this.types_ac=item.state
            this.pages.page=1
            this.get_list()
        },
        handle_seach(){
            console.log('点击搜索')
            this.pages.page=1
            this.get_list()
        },
        handleSizeChange(e){
            console.log('条数',e)            
            this.pages.page=1
            this.pages.limit=e
            this.get_list()
        },
        handleCurrentChange(e){
            console.log('页数',e)
            this.pages.page=e
            this.get_list()
        },
        handle_pages(i){
            console.log('首页尾页',i)
            this.pages.page=i
            this.get_list()
        },
        handle_deitial(item){
            this.$router.push({
                path:'/user_wt/user_wt_detial',
                query:{
                    id:item.id
                }
            })
        },
        get_list(){
            this.loading=true
            this.$api("userOrders", {
               
                status:this.types_ac,
                ...this.pages,
			}, "get").then((res) => {
                this.loading = false
                console.log('我的委托列表',res)
                if (res.code == 1) {
                    this.order_list=res.data.data
                    this.total=res.data.total
                    this.last_page=res.data.last_page
                } else {
                    alertErr(res.msg)
                }
            });
        },


    },

}
</script>
<style scoped lang="less">
.user_order {
    .order_titles{
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 56px;
    }
    .user_order_box{
        padding: 24px 32px;    
        margin-top: 24px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        .order_types{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .lefts{
                display: flex;
                align-items: center;
                .types{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    padding-bottom: 12px;
                    margin-right: 48px;
                    border-bottom: 4px solid #FFFFFF;
                    cursor: pointer;
                    &:hover{
                        border-bottom: 4px solid #377CFD;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #377CFD;
                    }
                }
                .types_ac{
                    border-bottom: 4px solid #377CFD;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #377CFD;

                }
            }
            .rights{
                /deep/.el-input{
                    width: 282px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    // border: 1px solid #B8C4D1;
                    .el-input__inner{
                        width: 282px;
                        height: 32px;
                    }
                    .el-input__suffix{
                        display: flex;
                        // line-height: 32px;
                        margin-right: 3px;
                        align-items: center;
                        cursor: pointer;
                        img{
                            width: 18px;
                        }
                    }
                }
            }
        }
        .order_0{
            text-align: center;
            padding-top: 65px;
            img{
               width: 190px; 
            }
            .texts{
                padding-top: 16px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;

            }
        }
        .order_list{
            padding-top: 23px;
            .order_tabs{
                width: 1132px;
                height: 44px;
                background: #F5F5F5;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #E5E5E5;
                display: flex;
                align-items:center;
                justify-content: space-between;
                padding: 0 24px;
                .tables{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #333333;

                }
                .tab1{
                    width: 270px;
                    flex-shrink: 0;
                }
                .tab2{
                    width: 210px;
                    flex-shrink: 0;
                }
                .tab3{
                    width: 170px;
                    flex-shrink: 0;
                }
                .tab4{
                    width: 160px;
                    flex-shrink: 0;
                }
                .tab5{
                    width: 160px;
                    flex-shrink: 0;
                }
            }
            .order_items{
                .items{
                    height: 100px;
                    border-left: 1px solid #E5E5E5;
                    border-right: 1px solid #E5E5E5;
                    border-bottom: 1px solid #E5E5E5;
                    padding: 0 24px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .item1{
                        width: 270px;
                        flex-shrink: 0;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 16px;
                        color: #333333;
                        img{
                            width: 70px;
                            margin-right: 22px;
                        }
                    }
                    .item2{
                        width: 210px;
                        flex-shrink: 0;
                        font-weight: 400;
                        font-size: 16px;
                        color: #333333;

                    }
                    .item3{
                        width: 170px;
                        flex-shrink: 0;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 16px;
                        color: #333333;

                    }
                    .item4{
                        width: 160px;
                        flex-shrink: 0;
                        display: flex;
                        align-items: center;
                        // justify-content: center;
                        .tages{
                            width: 88px;
                            height: 28px;
                            background: #E3E3E3;
                            border-radius: 2px 2px 2px 2px;
                            text-align: center;
                            line-height: 28px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;

                            // border: 1px solid #C7C7C7;
                        }
                        .tages1{
                            background: #E3E3E3;
                            border: 1px solid #C7C7C7;
                            color: #717171;

                        }
                        .tages2{
                            background: #FFBA7E;
                            border: 1px solid #FF9336;
                            color: #FF4600;

                        }
                        .tages3{
                            background: #E6F7FF;
                            border: 1px solid #1890FF;
                            color: #1890FF;

                        }
                        .tages4{
                            background: #F6FFED;
                            border: 1px solid #52C428;
                            color: #3BB363;

                        }
                        .tages5{
                            background: #FFC5C5;
                            border: 1px solid #D13838;
                            color: #E83A3A;

                        }
                    }
                    .item5{
                        width: 160px;
                        flex-shrink: 0;
                        display: flex;
                        align-items: center;
                        display: flex;
                        align-items: center;
                        // justify-content: flex-end;
                        .btns{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 16px;
                            color: #377CFD;
                            cursor: pointer;
                        }
                        .borders{
                            color:#D7D7D7 ;
                            font-size: 16px;
                            // background-color: #D7D7D7;
                            margin: 0 5px;
                        }
                    }
                }
            }
            
        }
        .pages_box{
                width: 100%;
                height: 100px;
                // background-color: red;
                display: flex;
                align-items: center;
                justify-content: end;
                /deep/.el-pagination{
                    .btn-prev{
                        background-color: #FFFFFF;
                        border: 1px solid #EEEEEE;  
                        
                    }
                    .el-pager{
                        .number {
                            background-color: #FFFFFF;
                            border: 1px solid #EEEEEE;  

                        }
                        .active{
                            background-color: #377CFD;
                        }
                        .el-icon{
                            background-color: #FFFFFF;
                        }
                    }
                    .btn-next{
                        background-color: #FFFFFF;
                        border: 1px solid #EEEEEE;  

                    }
                }
                .btns{
                    width: 40px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #EEEEEE;  
                    font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                    font-weight: normal;
                    font-size: 14px;
                    color: #7A7A7A;
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                }
            }
    }


}
</style>